export type GetUsersRequest = {
  userId?: string;
  userName?: string;
  includeDeletedUser?: boolean;
};
